export default function PieIcon6040Small() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.00001" cy="7.99992" r="6.47413" fill="#8EA5DB" fillOpacity="0.25" />
      <path
        d="M8 1.52583C6.97832 1.52583 5.97113 1.76764 5.0608 2.23147C4.15048 2.69531 3.36285 3.36801 2.76232 4.19457C2.16178 5.02113 1.7654 5.97808 1.60557 6.98719C1.44575 7.9963 1.52701 9.02891 1.84273 10.0006C2.15845 10.9723 2.69965 11.8554 3.42209 12.5779C4.14454 13.3003 5.0277 13.8415 5.99938 14.1572C6.97106 14.473 8.00367 14.5542 9.01278 14.3944C10.0219 14.2346 10.9788 13.8382 11.8054 13.2377L8 7.99997L8 1.52583Z"
        fill="#8EA5DB"
      />
    </svg>
  );
}
